module.exports = __webpack_public_path__ + "img/good.0137fa8b.png";